/**
 * @module enum
 */
export enum GroupApplicationTypeEnum {
    /**
     * 申请入群
     */
    V2TIM_GROUP_APPLICATION_GET_TYPE_JOIN,

    /**
     * 被邀请入群
     */
    V2TIM_GROUP_APPLICATION_GET_TYPE_INVITE,
}
